import React, { FC } from 'react';

import TextArea from '@ui/TextArea';
import FormFieldWrapper from '../Wrapper';
import { TextAreaProps } from 'antd/lib/input';

interface Props extends TextAreaProps {
  name: string;
  label?: React.ReactNode;
  help?: React.ReactNode;
}

const TextAreaField: FC<Props> = ({ name, label, help, ...props }) => (
  <FormFieldWrapper
    name={name}
    label={label}
    help={help}
    render={fieldProps => <TextArea {...props} {...fieldProps} />}
  />
);

export default TextAreaField;
